import { api, ContactPreferences } from './api';
import { storage } from './storage';

/**
 * Sunucu kesin kaynaktır. Eski sürümde cihazda kalmış true değeri, sunucuda henüz
 * satır yoksa ve açıkça seçilmiş hedef dil varsa bir kez taşınır. Ağ yoksa
 * çeviri açılmaz; yerel true değeri dil seçiminin yerine geçmez.
 */
export async function loadContactTranslationPreference(
  token: string,
  ownerId: number,
  contactId: number,
  knownRemote?: ContactPreferences | null,
): Promise<boolean> {
  const cached = await storage.getContactTranslation(ownerId, contactId).catch(() => false);
  if (knownRemote === null) return false;
  try {
    const remote = knownRemote ?? await api.getContactPreferences(token, contactId);
    if (!remote.translation_language) {
      await storage.setContactTranslation(ownerId, contactId, false).catch(() => {});
      return false;
    }
    if (!remote.configured && cached) {
      const migrated = await api.updateContactPreferences(token, contactId, {
        translation_enabled: true,
      });
      await storage.setContactTranslation(ownerId, contactId, migrated.translation_enabled)
        .catch(() => {});
      return migrated.translation_enabled;
    }
    await storage.setContactTranslation(ownerId, contactId, remote.translation_enabled)
      .catch(() => {});
    return remote.translation_enabled;
  } catch {
    return false;
  }
}

export async function saveContactTranslationPreference(
  token: string,
  ownerId: number,
  contactId: number,
  enabled: boolean,
  language?: string,
): Promise<boolean> {
  const saved = await api.updateContactPreferences(token, contactId, {
    translation_enabled: enabled,
    ...(language ? { translation_language: language } : {}),
  });
  await storage.setContactTranslation(ownerId, contactId, saved.translation_enabled)
    .catch(() => {});
  return saved.translation_enabled;
}
